/* eslint-disable @angular-eslint/prefer-inject */
/* eslint-disable @angular-eslint/component-selector */
import {Component, Inject} from '@angular/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DefectHistoryConstants } from 'src/app/modules/defect-history/models/constants/defect-history.constants';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import {provideNativeDateAdapter} from '@angular/material/core';
import { Router } from '@angular/router';

@Component({
  selector: 'date-range-dialog',
  providers: [provideNativeDateAdapter()],
  imports: [
    MatDialogModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  template: `
    <div class="container">
        <h2 mat-dialog-title>
            <b>{{this.defectConstants.dateRangeDialogTitle}}</b>
        </h2>
        <div class="dialog-content">
            <mat-dialog-content>
                <mat-form-field>
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [formGroup]="rangeForm" [rangePicker]="picker" [max]="maxDate" [min]="minDate">
                        <input matStartDate formControlName="start" placeholder="Start date">
                        <input matEndDate formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>

                    @if (rangeForm.controls.start.hasError('matStartDateInvalid')) {
                        <mat-error>Invalid start date</mat-error>
                    }
                    @if (rangeForm.controls.end.hasError('matEndDateInvalid')) {
                        <mat-error>Invalid end date</mat-error>
                    }
                </mat-form-field>
            </mat-dialog-content>
            <mat-dialog-actions>
                <button mat-button (click)="onCancel()" class="cancel-btn">
                    {{ defectConstants.cancelButtonText }}
                </button>
                <button
                    mat-button
                    cdkFocusInitial
                    (click)="onClose()"
                    class="confirm-btn"
                    [disabled]="rangeForm.invalid"
                >
                    {{ defectConstants.proceedButtonText }}
                </button>
            </mat-dialog-actions>
        </div>
    </div>
  `,
  styles: [`
    .container {
        width: 600px;
        height: 250px;
    }

    .cancel-btn {
        background-color: var(--cancel-button);
        color: white;
    }

    .confirm-btn {
        background-color: var(--save-button);
        color: white;
    }

    .confirm-btn:disabled {
        background-color: var(--disabled-button);
        cursor: not-allowed;
    }

    .dialog-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
  `]
})

export class DateRangeDialogComponent {
    //min date is two months before and max date is today
    maxDate = new Date(); // Current date
    minDate = new Date(this.maxDate.getFullYear(), this.maxDate.getMonth() - 2, this.maxDate.getDate());

    readonly rangeForm = new FormGroup({
        start: new FormControl<Date | null>(null, [Validators.required]),
        end: new FormControl<Date | null>(null),
    });

    constructor(public defectConstants: DefectHistoryConstants,
        public dialogRef: MatDialogRef<DateRangeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { startDate: Date | null, endDate: Date | null, id: number },
        private router: Router) 
    {
        dialogRef.disableClose = true;
    }

    onCancel(): void {
        //do not navigate
        this.dialogRef.close();
    }

    onClose(): void {
        //id 1 means the user is navigating from the home page
        //2 means they are on the defect history page and dont need to route just reload data
        const start = this.rangeForm.value.start;
        const end = this.rangeForm.value.end ?? start;

        if(this.data.id === 1) {
            this.dialogRef.close();
            this.router.navigate(['/cqms-dashboard/defect-history'], {
                queryParams: {
                    startDate: this.formatDate(start),
                    endDate: this.formatDate(end),
                },
            });
        } else if(this.data.id === 2) {
            this.dialogRef.close({
                startDate: this.formatDate(start),
                endDate: this.formatDate(end),
            });
        }
    }

    private formatDate(date: Date | null): string | null {
        if (!date) return null;
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${m}/${d}/${date.getFullYear()}`;
    }
}